import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/footer';
import Header from '../components/header';
const Careers = () => {
    useEffect(() => {
        document.title = ":: Career | Adber Infra India Pvt. Ltd. ::";
    }, []);
    return (
        <div>
            <Header />
            <section className="inner-page-banner-area gallery">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-8 col-sm-8 col-xs-12">
                            <div className="banner-caption contacttext">
                                <h1 className=""> Career </h1>
                                <p> Let us come together to create something extra-ordinary, aligned with our core purpose & values. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="breadcrumbs-area">
                <div className="container-fluid">
                    <ol className="breadcrumb">
                        <li><Link to="/"> Home </Link></li>
                        <li> Career </li>
                    </ol>
                </div>
            </div>

            <div className="container" id="InternalPageArea">
                <div className="row">
                    <div className="col-sm-12 col-xs-12 ">
                        <h3> Director’s Message </h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 col-sm-4 col-xs-12 ">
                        <div className="imgWrapper">
                            <img src="../assets/images/suyash-lohokare.jpg" alt="Mr. Suyash Lohokare" title="Mr. Suyash Lohokare" />
                        </div>
                    </div>
                    <div className="col-md-8 col-sm-8 col-xs-12 ">
                        <div className="profTxt">
                            <blockquote>
                                <div className="blockquote-icon">
                                    <img src="../assets/images/icon/quote.png" alt="" />
                                </div>
                                <div className="blockquote-text">
                                    <p> We are excited that you have decided to join us and look forward to a long, happy & successful association together. You have been hired because we believe you can help us to deliver high level of integrity. </p>

                                    <p> Friends, as we are moving in this competitive world of 21<sup>st</sup> century, we should think globally and critically and in this journey I suggest you should have some skill by accepting this habits like- </p>

                                    <ul className="commanListstyle">
                                        <li> Set aside 30 minutes a day to improve your brain function.</li>
                                        <li> Read great books</li>
                                        <li> Put yourself in others people shoes.</li>
                                        <li> Think several moves ahead.</li>
                                        <li> Implement what you learn </li>
                                    </ul>

                                    <p> I am confident that this will help you in your personal as well as professional journey. </p>

                                    <p> Let us come together to create something extra-ordinary, aligned with our core purpose & values. </p>

                                    <p> With Best Wishes , <br /> <b> Suyash Lohokare </b> </p>
                                </div>
                            </blockquote>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-12 col-xs-12 ">
                        <h3> Grow with Us </h3>
                    </div>
                    <div className="col-sm-12 col-xs-12 ">
                        <div className="hrWrapper">
                            <div className="inneWrapper">
                                <p> Please Send Your Resume to
                                    <a href="mailto:hr@adberinfra.co.in"> hr@adberinfra.co.in </a> </p>
                                <p> Contact To Our HR <b> Mayur Marsale, </b><br />
                                    (HR Manager) <br />
                                    7768022900 / 8956253534.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Careers;
